import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import {
  CustomerDocumentMagicLink,
  getCustomerDocumentMagicLink
} from '@/services/magicLinkService';

const CustomerDocumentMagicLinkPage = () => {
  const { artifactId } = useParams();
  const [link, setLink] = useState<CustomerDocumentMagicLink | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!artifactId) {
      setError('This document link is missing its identifier.');
      return;
    }

    let cancelled = false;

    getCustomerDocumentMagicLink(artifactId)
      .then((result) => {
        if (cancelled) {
          return;
        }

        setLink(result);
        window.location.replace(result.downloadUrl);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(
            err instanceof Error
              ? err.message
              : 'This document link is unavailable.'
          );
        }
      });

    return () => {
      cancelled = true;
    };
  }, [artifactId]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        textAlign: 'center',
        bgcolor: 'background.paper'
      }}
    >
      {error ? (
        <Typography color="text.secondary">{error}</Typography>
      ) : link ? (
        <Box sx={{ display: 'grid', gap: 2, justifyItems: 'center' }}>
          <Typography variant="h6">{link.documentName}</Typography>
          <Typography color="text.secondary">
            Your document should open automatically.
          </Typography>
          <Button href={link.downloadUrl} variant="contained">
            Open document
          </Button>
        </Box>
      ) : (
        <Box sx={{ display: 'grid', gap: 2, justifyItems: 'center' }}>
          <CircularProgress size={28} />
          <Typography color="text.secondary">Opening document...</Typography>
        </Box>
      )}
    </Box>
  );
};

export default CustomerDocumentMagicLinkPage;
